import React from 'react';

export enum CalendarIconTestID {
  CalendarIcon = 'CalendarIconTestID.CalendarIcon',
}

interface Props {
  // Date to render in the calendar icon
  date: Date;
}

export const CalendarIcon: React.FC<Props> = ({ date }) => {
  return (
    <div
      data-testid={CalendarIconTestID.CalendarIcon}
      className="flex flex-col"
      style={{
        height: 60,
        width: 60,
      }}
    >
      <div className="w-full text-center pt-1 rounded-t text-sm text-white font-extrabold bg-blue-200">
        {date.toLocaleDateString('en', { month: 'short' })}
      </div>
      <div className="w-full h-full text-center p-2 rounded-b text-xl text-gray-900 font-black bg-gray-100">
        {date.getDate()}
      </div>
    </div>
  );
};
